import { initAjaxLoadItemsTrigger } from 'allink-core-static/js/modules/ajax-load-items';
import { initMasonry } from 'allink-core-static/js/modules/masonry';

$(function(){

    var options = {
        ajax_load_transition_duration: 100,
    };

    // init modules
    initAjaxLoadItemsTrigger(options);
    initMasonry(options);

    // re-init when softpage has been opened
    $(window).on('softpage:opened',function(){
        initAjaxLoadItemsTrigger(options);
        initMasonry(options);
    });

    // hide load more container in case the user is searching by term
    $(window).on('ajaxForm:request-sent',function(e,$form){
        // init
        var $plugin_container = $form.parents('.work-search-plugin');
        if ($plugin_container.length > 0) {
            $plugin_container.find('.ajax-items-container').addClass('loading');
        }
    });

    // hide load more container in case the user is searching by term
    $(window).on('ajaxForm:success',function(e,$form){
        // init
        var $plugin_container = $form.parents('.work-search-plugin');
        if ($plugin_container.length > 0) {
            $plugin_container.find('.load-more-container').hide();
            $plugin_container.find('.ajax-items-container').removeClass('loading');
        }
    });

});



// WEBPACK FOOTER //
// ./static/js/modules/ajax-load-items.js